const translations = {
  "login.Title": "სისტემაში შესვლა",
  "login.Username": "მომხმარებლის სახელი",
  "login.Password": "პაროლი",
  "login.UserNotFound": "მომხმარებელი / პაროლი არასწორია!",
  "login.Login": "შესვლა",
  "login.RememberMe": "დამახსოვრება",
  "login.ForgotPassword": "დაგავიწყდათ პაროლი?",
  USER_PASS_INCORRECT: "მომხმარებელი / პაროლი არასწორია!",

  "new-password": "ახალი პაროლი",
  "repeat-new-password": "გაიმეორე პაროლი",
  getSMScode: "SMS კოდის მიღება",
  next: "შემდეგი",
  "login.PasswordIsIncorrect": "პაროლი არასწორია",
  smsAuth: "SMS ავტორიზაცია",
  auth: "ავტორიზაცია",
  registration: "რეგისტრაცია",
  "recover-pass": "პაროლის აღდგენა",
  // "cant-find-policy": "სამწუხაროდ, აღნიშნული პირადი ნომრით აქტიური პოლისი ვერ მოიძებნა",
  "cant-find-policy":
    "განახლებულ პორტალზე შესასვლელად, გთხოვთ გაიაროთ რეგისტრაცია",
  "auth-regis-code": "ერთჯერადი კოდით ავტორიზაცია/რეგისტრაცია",
  "passwrod-auth": "პაროლით ავტორიზაცია",
  "passwrod-validate":
    "პაროლი უნდა შეიცავდეს შემდეგ სიმბოლოებს (მინიმუმ 8 სიმბოლო, ციფრები)",
  "passwrod-has-space": "პაროლი არ უნდა შეიცავდეს ცარიელ სივრცეს",
  "passwrod-dont-match": "პაროლები არ ემთხვევა",
  "passwrod-matches-old": "ძველი და ახალი პაროლი არ უნდა იყოს ერთნაირი",
  "have-account": "გაქვს ანგარიში? ",

  "login.instrucation": "ინსტრუქცია",
  "login.personalInfo": "პირადი ინფორმაცია",
  "login.lessthen18_1":
    "ვინაიდან არ ხარ სრულწლოვანი, ნომრის ცვლილება უნდა განახორციელოს შენმა დამზღვევმა მშობელმა ",
  "login.lessthen18_2": "გთხოვ, შენმა დამზღვევმა მშობელმა ",
  "login.lessthen18_3": " -მ გაიაროს იდენტომატით იდენტიფიცირება.",
  "login.insurerPid": "დამზღვევის პირადი ნომერი",
  "login.approveTitle": "თანხმობა დისტანციურ იდენტიფიკაციაზე",
  "login.approve.parag_1":
    "თანხმობა იდენტიფიკაციაზე/პერსონალურ მონაცემთა დამუშავებაზე:",
  "login.approve_parag_2":
    "თანხმობას ვაცხადებ, რომ დისტანციური იდენტიფიკაციის მიზნით, სს ,,სადაზღვევო კომპანია იმედი ელ“-მა და მისმა უფლებამოსილმა პირმა - შპს „რაიზომატ“-მა (საიდენტიფიკაციო ნომერი: 402102005, რეგისტრირებული მისამართი: საქართველო, თბილისი, ჩუღურეთის რაიონი, დავით აღმაშენებლის გამზ., №86/90) მიიღოს და დაამუშაოს ჩემი ბიომეტრიული მონაცემები, (რისთვისაც შეუძლია გადაიღოს ფოტო და/ან გადაიღოს ჩემი სახის ცოცხალი გამოსახულება) ან/და ჩემი პირადი იდენტიფიცირებისთვის გამოყენებული სხვა დოკუმენტები. ",
  "login.approve_parag_3":
    "მიღებული მონაცემები შესაძლოა დამუშავდეს საქართველოს საზღვრებს გარეთ დაცულ სერვეზე გერმანიაში, დაშიფრული სახით, მონაცემთა შინაარსზე წვდომის გარეშე. ვაცნობიერებ, რომ ჩემი ბიომეტრიული მონაცემები დამუშავდება მომსახურების გაწევის მიზნით, მოქმედი კანონმდებლობის მოთხოვნათა შესაბამისად, იმ მოცულობით და ფარგლებში, რაც საჭიროა მომსახურების გასაწევად. დისტანციური იდენტიფიკაციისთვის მიღებული ჩემი მონაცემების შენახვა განხორციელდება დისტანციური იდენტიფიკაციიდან 5 წლის მანძილზე.",
  "login.approve_parag_4":
    " ამასთან, ინფორმირებული ვარ, რომ მაქვს ჩემს მონაცემებზე წვდომის მოთხოვნის და ასევე აღნიშნული მონაცემების შესწორების, წაშლის, მათი დამუშავების შეზღუდვის, ასევე თანხმობის გამოხმობის, დამუშავებაზე უარის განცხადების უფლება. წინამდებარე დოკუმენტით ვაცხადებ და ვადასტურებ, რომ მთელი ჩემი პირადი მონაცემები, რომლებსაც წარმოვადგენ ჩემი დისტანციური იდენტიფიკაციის მიზნით, სწორია და ზუსტი. ვაცხადებ, რომ დისტანციური იდენტიფიკაციის განხორციელებით, ვეთანხმები იმ წესებსა და პირობებს, რომელიც განთავსებულია უფლებამოსილი პირის",
  "login.approve.parag_5": "ვებ გვერდზე.",
  "login.approve.parag3454":
    "**ორჯერ ზედიზედ წარუმატებლად იდენტიფიცირების შემთხვევაში, თქვენ ორი საათით შეგეზღუდებათ იდენტომატით სარგებლობა. გთხოვთ, მიჰყვეთ ინსტრუქციას და დარწმუნდეთ, რომ ფოტოების ხარისხი მისაღებია და მათზე არსებული მონაცემები იკითხება, მათ დადასტურებამდე.",
  "login.validat-title": "იდენტომატის პროცესი წარმატებით გაიარე!",
  "login.validat-paag": "გთხოვ, გაიარე ახალი ტელეფონის ნომრით იდენტიფიკაცია",
  mobileNum: "ტელეფონის ნომერი",
  "vali-title": "შენ ვერ გაიარე იდენტომატის პროცესი!",
  "validat-again": " გთხოვ, სცადო თავიდან",

  "login.persInfo": "პირადი ინფორმაცია",
  "login.remoteAgreement": "თანხმობა დისტანციურ იდენტიფიკაციაზე",
  "login.remoteAgreementIdentomat":
    "დისტანციური იდენტიფიკაცია იდენტომატის დახმარებით",

  MinLength: "პაროლი უნდა იყოს მინიმუმ 8 სიმბოლო.",
  "MissingA-Z": "პაროლში უნდა იყოს მინიმუმ ერთი დიდი ასო (A–Z).",
  "Missinga-z": "პაროლში უნდა იყოს მინიმუმ ერთი პატარა ასო (a–z)",
  "Missing0-9": "პაროლში უნდა იყოს მინიმუმ ერთი ციფრი (0–9).",
  MissingSpecSymbols:
    "პაროლში უნდა იყოს მინიმუმ ერთი სპეციალური სიმბოლო, როგორიცაა: ! @ # $ % ^ & *.",
  OnlyLatin: "პაროლი უნდა შეიცავდეს მხოლოდ ლათინურ ასოებს",
};

export default translations;
